import { ProductLineName } from "../../models/products/collection";

export const hasBottomPole: ProductLineName[] = [
  ProductLineName.MontereyPulleyLift,
  ProductLineName.MontereyAutoTilt,
  ProductLineName.MontereyCrank,
  ProductLineName.Greenwich,
  ProductLineName.Catalina,
  ProductLineName.Laurel
];
